import React from "react";
import classnames from "classnames";

export const ProductQuickCompare = ({ productMatches, onZoomCompare, selectedProductCompare }) => {
    return (
        <div className="compare-buttons -wrap">
            {productMatches &&
                productMatches.map((match, index) => {
                    const selected = match.taskContextKey === selectedProductCompare.taskContextKey;

                    return (
                        <div
                            style={{ display: "inherit" }}
                            key={index}
                        >
                            <button
                                className={classnames("link -separator", { "-selected": selected })}
                                onClick={() => onZoomCompare(match.taskContextKey)}
                            >
                                Product Match {index + 1}
                            </button>
                            <div className="separator" />
                        </div>
                    );
                })}
        </div>
    );
};
